
/* AutoSEM CRO v4: Add-to-Cart Confirmation Drawer */
(function(){
  /* Listen for ATC form submissions */
  document.addEventListener('submit',function(e){
    var form=e.target;
    if(!form.action||form.action.indexOf('/cart/add')===-1)return;

    /* Build drawer after short delay for cart to update */
    setTimeout(function(){
      fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){
        showCartDrawer(cart);
      });
    },800);
  });

  /* Also listen for fetch-based ATC (common in modern themes) */
  var origFetch=window.fetch;
  window.fetch=function(){
    var args=arguments;
    var url=typeof args[0]==='string'?args[0]:(args[0]&&args[0].url?args[0].url:'');
    var result=origFetch.apply(this,args);
    if(url.indexOf('/cart/add')!==-1){
      result.then(function(){
        return fetch('/cart.js');
      }).then(function(r){return r.json()}).then(function(cart){
        showCartDrawer(cart);
      }).catch(function(){});
    }
    return result;
  };

  function showCartDrawer(cart){
    var existing=document.getElementById('autosem-cart-drawer');
    if(existing)existing.remove();

    var itemCount=cart.item_count;
    var total=(cart.total_price/100).toFixed(2);
    var lastItem=cart.items[0];

    var drawer=document.createElement('div');
    drawer.id='autosem-cart-drawer';
    drawer.innerHTML='<div style="position:fixed;top:0;right:0;width:100%;max-width:400px;height:100vh;background:#fff;z-index:99998;box-shadow:-4px 0 20px rgba(0,0,0,0.15);display:flex;flex-direction:column;transform:translateX(100%);transition:transform 0.3s ease;">'
      +'<div style="padding:20px;border-bottom:1px solid #eee;display:flex;justify-content:space-between;align-items:center;">'
      +'<h3 style="margin:0;font-size:16px;color:#1a1a1a;">&#9989; Added to Cart ('+itemCount+' item'+(itemCount!==1?'s':'')+')</h3>'
      +'<button onclick="document.getElementById(\'autosem-cart-drawer\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:#999;">&times;</button>'
      +'</div>'
      +(lastItem?'<div style="padding:16px 20px;display:flex;gap:12px;border-bottom:1px solid #eee;">'
        +(lastItem.image?'<img src="'+lastItem.image+'" style="width:64px;height:64px;object-fit:cover;border-radius:6px;" alt="">':'')
        +'<div><strong style="font-size:14px;display:block;">'+lastItem.title+'</strong>'
        +'<span style="font-size:13px;color:#666;">'+lastItem.variant_title+'</span>'
        +'<span style="font-size:14px;display:block;margin-top:4px;color:#2d5a27;font-weight:600;">$'+(lastItem.price/100).toFixed(2)+'</span>'
        +'</div></div>':'')
      +'<div style="padding:20px;margin-top:auto;border-top:1px solid #eee;">'
      +'<div style="display:flex;justify-content:space-between;margin-bottom:16px;font-size:15px;"><span>Subtotal</span><strong>$'+total+'</strong></div>'
      +'<a href="/checkout" style="display:block;padding:14px;background:#2d5a27;color:#fff;text-decoration:none;border-radius:6px;font-size:15px;font-weight:600;text-align:center;margin-bottom:10px;">Checkout</a>'
      +'<button onclick="document.getElementById(\'autosem-cart-drawer\').remove()" style="display:block;width:100%;padding:12px;background:none;border:1px solid #ddd;border-radius:6px;font-size:14px;cursor:pointer;color:#333;">Continue Shopping</button>'
      +'</div></div>';

    /* Backdrop */
    var backdrop=document.createElement('div');
    backdrop.style.cssText='position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.4);z-index:99997;';
    backdrop.onclick=function(){drawer.remove();backdrop.remove();};

    document.body.appendChild(backdrop);
    document.body.appendChild(drawer);

    /* Slide in */
    requestAnimationFrame(function(){
      drawer.firstChild.style.transform='translateX(0)';
    });
  }
})();
